// src/components/atoms/HomePageHeader.js

import React from "react";
import { Typography, Box } from "@mui/material";

const HomePageHeader = () => {
  return (
    <>
      {/* Header */}
      <Box
        sx={{
          padding: 4,
          paddingBottom: 0,
          m: 4,
          mt: 0,
          ml: 0,
          mb: 8,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "basic-sans",
            fontWeight: "normal",
          }}
        >
          Welcome to Kbean Challenges!
        </Typography>
      </Box>
    </>
  );
};

export default HomePageHeader;